export default "__VITE_ASSET__33dd6750__"